import React from 'react';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../redux/store';
import { SxProps } from '@mui/material';
import { defaultBorder } from '../../../Theme';
import { CustomTreeLeaf } from './CustomTreeLeaf';

const treeViewSx: SxProps = {
    height: '100%',
    overflowY: 'auto',
    marginLeft: 'unset',
    '& .MuiTreeItem-group': {
        ml: 3.5,
    },
    '& .MuiTreeItem-content': {
        borderBottom: defaultBorder,
        padding: '0px 8px',
    },
};

export default ({ noteId }: { noteId: string }) => {
    const { communicationDocuments } = useSelector(
        (_store: IAppReduxStore) => _store.projectAdditionalDocs,
    );

    return (
        <SimpleTreeView sx={treeViewSx}>
            {(communicationDocuments?.[noteId] ?? []).map(doc => (
                <TreeItem
                    key={doc.NoteId}
                    itemId={doc.NoteId}
                    sx={{ alignItems: 'center' }}
                    ContentComponent={CustomTreeLeaf({
                        doc,
                        disableClick: true,
                        small: true,
                        hasChildren: false,
                    })}
                />
            ))}
        </SimpleTreeView>
    );
};
